import { render, staticRenderFns } from "./IO.vue?vue&type=template&id=16e6a6bb&"
var script = {}


/* normalize component */
import normalizer from "!../../../../Users/atec/.config/yarn/global/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports